import _ from "lodash/fp";
import {combineReducers} from "redux";
import {combineActions, handleActions} from "redux-actions";
import {createSigntask} from "./createSigntask";
import {deactivateSigntask} from "./deactivateSigntask";
import {fetchSigntask} from "./fetchSigntask";
import {fetchSigntasks} from "./fetchSigntasks";
import {fetchOrderStatus} from "./fetchOrderStatus";

export default combineReducers({
  data: handleActions(
    {
      [combineActions(
        createSigntask.success,
        deactivateSigntask.success,
        fetchSigntask.success,
        fetchSigntasks.success)]: (state, {payload}) => _.merge(state, payload),
      [fetchOrderStatus.success]: (state, {payload, meta}) => _.merge(state, {
        [meta.signtaskId]: {
          signers: {
            [meta.ssn]: {
              status: {
                [meta.documentReference]: payload.status
              }
            }
          }
        }
      })
    },
    {}
  ),
  meta: handleActions(
    {
      [fetchSigntasks.success]: ({loadedPages}, {meta: {page, pageSize, numElements, numPages}}) => ({
        loadedPages: _.uniq([...loadedPages, page]),
        numElements,
        numPages
      })
    },
    {
      loadedPages: [],
      numElements: undefined,
      numPages: undefined
    }
  )
});
